import React, { useEffect } from 'react'
import axios from 'axios';
import Header from './AdminHeader.jsx';
import Menu from './AdminMenu.jsx';
import Footer from './AdminFooter.jsx';
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const Layout = ({ children }) => {
    useEffect(() => {
        const checkSession = async () => {
            try {
                const res = await axios.get(`${baseAPIUrl}admin/login/check_session`, {
                    withCredentials: true
                });
                if (res.data && res.data.status === 0) {
                    localStorage.removeItem("isLoggedIn");
                    localStorage.removeItem("school_slugs");
                    window.location.href = "/admin";
                }
            } catch (err) {
                console.error("Session check failed", err);
            }
        };
        checkSession();
    }, []);

    return (
      <div className="wrapper">
        <Header/>
        <Menu/>
        <main>{children}</main>
        <Footer/>
      </div>
    )
}
export default Layout;